module.exports = {"writeKey":"DUMMY WRITE KEY"}


//////////////////
// WEBPACK FOOTER
// app/js/credentials/segmentIO.credentials.json
// module id = 399
// module chunks = 0